import { getCookie } from './cookie-handler';

/**
 * @returns {Number}
 */
export function getCartCount() {
    return parseInt(getCookie('_bo_basket_count'), 10) || 0;
}

/**
 * @returns {Number}
 */
export function getCartExpiration() {
    const expiration = parseInt(getCookie('_bo_ticket_expiration_time'), 10);

    if (expiration) {
        return expiration * 1000;
    }

    return null;
}

/**
 * @returns {Boolean}
 */
export function isBasketTimerHidden() {
    return parseInt(getCookie('_bo_hide_basket_timer'), 10) === 1;
}

/**
 * @returns {Boolean}
 */
export function getLoggedIn() {
    return parseInt(getCookie('_bo_logged_in'), 10) === 1;
}

/**
 * @returns {Number}
 */
export function getLoginModeOfSale() {
    return parseInt(getCookie('login_mos'), 10);
}

/**
 * @returns {Number}
 */
export function getModeOfSale() {
    return parseInt(getCookie('_bo_mos'), 10);
}

/**
 * @returns {String}
 */
export function getUserName() {
    return getCookie('bo_first_name');
}

/**
 * @returns {Number}
 */
export function getCustomerNumber() {
    return parseInt(getCookie('bo_customer_number'), 10) ?? null;
}

/**
 * @returns {String}
 */
export function getPromoCode() {
    const promoCode = getCookie('_bo_active_promo_code');

    if (!promoCode || promoCode === undefined || promoCode === null) {
        return null;
    }

    return promoCode;
}

/**
 * @returns {Boolean}
 */
export function hasMemberships() {
    return parseInt(getCookie('_bo_customer_has_memberships'), 10) === 1;
}

/**
 * @returns {Boolean}
 */
export function hasSubscriptions() {
    return parseInt(getCookie('_bo_customer_has_subscriptions'), 10) === 1;
}

export default {
    getCartCount,
    getCartExpiration,
    isBasketTimerHidden,
    getLoggedIn,
    getLoginModeOfSale,
    getModeOfSale,
    getUserName,
    getCustomerNumber,
    getPromoCode,
    hasMemberships,
    hasSubscriptions,
}
